import React from 'react'
import NumberFormat from 'react-number-format'

const NumberFormatCustomNoDecimals = React.memo(propis => {
  const { inputRef, onChange, prefix, ...other } = propis
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      fixedDecimalScale
      defaultValue="1"
      onValueChange={values => {
        onChange({
          target: {
            value: values.value,
          },
        })
      }}
      thousandSeparator="."
      decimalSeparator=","
      isNumericString
      decimalScale={0}      
      format="###x"
      prefix={prefix}
    />
  )
})

export default NumberFormatCustomNoDecimals
